<template>
  <div class="cc-media-logo">
    <template v-if="view.kind === 'composed'">
      <img
        :src="view.mediaSrc"
        :alt="mediaName"
        class="cc-media-logo__media"
        @load="emit('load', $event)"
        @error="mediaLogoFailed = true"
      />
      <span class="cc-media-logo__times" aria-hidden="true">×</span>
      <img :src="yagishLogoSrc" alt="yagish" class="cc-media-logo__yagish" />
    </template>
    <img
      v-else-if="view.kind === 'static'"
      :src="view.src"
      :alt="mediaName ? `${mediaName} × yagish` : 'yagish'"
      class="cc-media-logo__static"
      @load="emit('load', $event)"
    />
    <span v-else class="cc-media-logo__text"
      >{{ mediaName || 'キャリコネ転職' }} × yagish</span
    >
  </div>
</template>

<script setup lang="ts">
/**
 * キャリコネクションの「連携先の企業ロゴ × yagish ロゴ」。
 * RT1.0 ダイアログと完了画面の DL バナーで共通に使う（presentational）。
 */
import { computed, ref, watch } from 'vue'
import {
  YAGISH_LOGO_SRC,
  resolveCcLogoView
} from '@/utils/realtime-transfer/careerconnectionLogo'

const props = withDefaults(
  defineProps<{
    /** ①が返した連携先ロゴの URL（logo_img_url） */
    mediaLogo?: string
    /** 連携先名（alt と文字表示に使う） */
    mediaName?: string
    /** 連携先ロゴが出せないときの固定画像（rt_condition.content） */
    fallbackSrc?: string
  }>(),
  { mediaLogo: '', mediaName: '', fallbackSrc: '' }
)

const emit = defineEmits<{ (e: 'load', event: Event): void }>()

const yagishLogoSrc = YAGISH_LOGO_SRC
const mediaLogoFailed = ref(false)
// 媒体が変わったら読み込み失敗の記録を戻す
watch(
  () => props.mediaLogo,
  () => {
    mediaLogoFailed.value = false
  }
)

const view = computed(() =>
  resolveCcLogoView(props.mediaLogo, props.fallbackSrc, mediaLogoFailed.value)
)
</script>

<style lang="scss" scoped>
.cc-media-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-width: 0;

  &__media,
  &__yagish {
    height: 36px;
    min-width: 0;
    object-fit: contain;
  }

  &__media {
    max-width: 55%;
  }

  &__yagish {
    max-width: 35%;
  }

  &__times {
    flex-shrink: 0;
    font-size: 20px;
    font-weight: bold;
    line-height: 1;
    color: #e91044;
  }

  &__static {
    max-width: 100%;
    max-height: 80px;
    object-fit: contain;
  }

  &__text {
    font-size: 16px;
    font-weight: bold;
  }
}
</style>
